	import {
		loadScript
	} from "@paypal/paypal-js";
	import {
		EventBus
	} from "../scripts/_eventBus.js";

	export default {
		computed: {
			paypalImage() {
				return this.Reservation.Payment.Method === "Paypal" ? "/icons/paypal.svg" : "/icons/paypal_grey.svg";
			}
		},
		methods: {
			async initPaypal() {
				let paypal = await loadScript({
						"client-id": this.Channel.Payment.Paypal.ClientID,
						"commit": true,
						"currency": "EUR"
					})
					.catch((error) => this.log(error, "paypal loadScript failed", "Error"))

				//
				this.paypalRender(paypal);
			},
			paypalRender(paypal) {
				if (this.totalSum <= 0 && this.Channel.Payment.Methods.indexOf("Paypal") === -1) return;
				let self = this;

				paypal.Buttons({
					fundingSource: paypal.FUNDING.PAYPAL,
					style: {
						label: "pay",
						shape: "pill"
					},
					onClick(data, actions) {
						return self.$refs.observer.validate().then((isValid) => {
							return isValid ? actions.resolve() : actions.reject();
						});
					},
					createOrder: function (data, actions) {
						const total = self.totalSum;
						const reservation = self.Reservation.fn.get();

						if (self.isNewPayment) {
							return self.preauth(reservation)
								.then(() => {
									return self.Reservation._Payment.PayPal.PayID
								});
						} else {
							// Create individual items for paypal
							const items = reservation.Products.map(product => {
								return {
									name: product.Name,
									quantity: product.Selling.Count,
									unit_amount: {
										currency_code: "EUR",
										value: product.Selling.Price,
									},
									category: "DIGITAL_GOODS",
									description: self.tryGetProductDescription(reservation, product),
								}
							});

							return actions.order.create({
								purchase_units: [{
									amount: {
										value: total,
										currency_code: "EUR",
										breakdown: {
											item_total: {
												value: total,
												currency_code: "EUR",
											}
										}
									},
									description: self.T("ticketing_booking_for", self.Channel.Address.Venue.Name),
									invoice_id: self.Reservation._uuid,
									items,
								}],
								application_context: {
									brand_name: "oneticketing", // self.Channel.Address.Venue.Name
									shipping_preference: "NO_SHIPPING",
								}
							});
						}
					},
					onApprove: async function (data, actions) {
						var reservation = self.Reservation.fn.get();

						if (self.isNewPayment) {
							reservation._Payment.PayPal = {
								OrderID: data.orderID,
								PayerID: data.payerID,
								PaymentID: data.paymentID,
								PaymentToken: data.paymentToken
							}
						} else {
							reservation.Payment.Paypal = {
								OrderID: data.orderID,
								PayerID: data.payerID,
								PaymentID: data.paymentID,
								PaymentToken: data.paymentToken
							};
						}

						// save the reservation synchronously
						EventBus.$emit("loading_start");
						//
						try {
							await self.deleteBlockedCapacities();
						} catch (err) {
							// do nothing
							console.error("Delete blocked capacity failed: ", err);
						}
						const command = `/book/${self.Channel.Directory}`;
						const result = self.apiPostSynchronously(command, reservation);

						//
						if (result.Meta && result.Meta.IsValid && result.Value.IsValid) {
							self.validation.errors = [];
							const onAfter = () => {
								self.$router.replace({
									name: "confirmation"
								});
								window.setTimeout(() => {
									EventBus.$emit("checkout_onAfterBook", result.Value);
									EventBus.$emit("loading_end");
								}, 100);
							}

							if (self.isNewPayment) {
								onAfter();
							} else {
								return actions
									.order
									.capture()
									.then(() => {
										onAfter();
									});
							}
						} else {
							self.validation.errors = result.Value.Validation.Errors;
							self.$modals.show("checkout.validation");
							EventBus.$emit("loading_end");
						}
					},
					onError: function (error) {
						self.log(error, "paypalRender failed", "Error");
					}
				}).render('#paypal-button');
			},
		}
	}